import { render, staticRenderFns } from "./ups-downs-futures.vue?vue&type=template&id=55bba5d4&scoped=true&"
import script from "./ups-downs-futures.vue?vue&type=script&lang=js&"
export * from "./ups-downs-futures.vue?vue&type=script&lang=js&"
import style0 from "./ups-downs-futures.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ups-downs-futures.vue?vue&type=style&index=1&id=55bba5d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bba5d4",
  null
  
)

export default component.exports